import { useState, useEffect } from "react";
import { Drawer } from "antd";
import { CloseOutlined, LineHeightOutlined } from "@ant-design/icons";
import HeaderChat from "./headerChat";
import MessageInput from "./messageInput";
import ContentChat from "./contentChat";
import { getMurphyPanelAsistente } from "../globals.js";

const ChatDrawer = ({
  open,
  onClose,
  messages,
  responses,
  files,
  handleSendMessage,
  handleReceiveMessage,
  handleSendFile,
  exitChat,
  onSessionExpired,
}) => {
  const [drawerWidth, setDrawerWidth] = useState(400);
  const [resizing, setResizing] = useState(false);
  const [textSize, setTextSize] = useState(14);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (resizing) {
        const newWidth = window.innerWidth - e.clientX;
        if (newWidth < 350) {
          setDrawerWidth(350);
        } else if (newWidth > window.innerWidth - 20) {
          setDrawerWidth(window.innerWidth - 20);
        } else {
          setDrawerWidth(newWidth);
        }
      }
    };

    const handleMouseUp = () => setResizing(false);

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [resizing]);

  const sizeText = () => {
    // Ciclo: 12 -> 14 -> 18 -> 22 -> 12 ...
    let newSize;
    if (textSize === 12) newSize = 14;
    else if (textSize === 14) newSize = 18;
    else newSize = 12;
    setTextSize(newSize);
  };

  return (
    <>
      <Drawer
        width={drawerWidth}
        placement="right"
        className="murphy-drawer"
        style={{
          backgroundColor: getMurphyPanelAsistente("bgColorGlobal"),
        }}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <HeaderChat />
            <LineHeightOutlined
              style={{
                color: getMurphyPanelAsistente("titleColor"),
                fontSize: "16px",
                cursor: "pointer",
                position: "relative",
                right: 30,
                marginTop: 30,
              }}
              onClick={sizeText}
            />
          </div>
        }
        footer={
          <MessageInput
            onSendMessage={handleSendMessage}
            onReceiveMessage={handleReceiveMessage}
            onSendFile={handleSendFile}
            onSessionExpired={onSessionExpired}
            setIsLoading={setIsLoading}
          />
        }
        onClose={exitChat}
        open={open}
        closeIcon={
          <CloseOutlined
            style={{
              color: getMurphyPanelAsistente("titleColor"),
              fontSize: "20px",
              cursor: "pointer",
              width: "20px",
              height: "20px",
            }}
            onClick={onClose}
          />
        }
      >
        <ContentChat
          messages={messages}
          response={responses}
          files={files}
          textSize={textSize}
          isLoading={isLoading}
        />
      </Drawer>

      {/* Handler al lado del drawer */}
      {open && (
        <div
          onMouseDown={() => setResizing(true)}
          style={{
            position: "fixed",
            top: 0,
            right: drawerWidth, // justo pegado al Drawer
            bottom: 0,
            width: "6px",
            cursor: "ew-resize",
            backgroundColor: "transparent",
            borderLeft: "1px solid #ccc",
            zIndex: 2000,
          }}
        />
      )}
    </>
  );
};

export default ChatDrawer;
